/* eslint-disable */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { HighlightOff as CancelIcon, Delete as Trash } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid, validate } from 'uuid';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import _ from 'lodash';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXFinalFormDataReplicator from '../form-data-replicator/QCXFinalFormDataReplicator';
import QCXTabsManager from '../tabs/QCXTabsManager';
import QCXRelacaoFornecedorFieldGroup from '../relacao-fornecedor/QCXRelacaoFornecedorFieldGroup';
import { fetchAdicoesByDiDuimpIdAsync } from '../../features/declaracao-importacao/declaracaoImportacaoThunks';
import {
  loading,
  setModel,
  resetStatus,
  resetAdicoes,
} from '../../features/declaracao-importacao/declaracaoImportacaoSlice';
import QCXSelectCoberturaCambialAutocomplete from '../../shared-components/select-cobertura-cambial/QCXSelectCoberturaCambialAutocomplete';
import QCXSelectMotivoImportacaoSemCoberturaCambialAutocomplete from '../../shared-components/select-motivo-importacao-sem-cobertura-cambial/QCXSelectMotivoImportacaoSemCoberturaCambialAutocomplete';
import QCXSelectVinculoCompradorVendedorAutocomplete from '../../shared-components/select-vinculo-comprador-vendedor/QCXSelectVinculoCompradorVendedorAutocomplete';
import QCXSelectCFOPOperacoesFiscaisAutocomplete from '../../shared-components/final-autocomplete-select-cfop-operacoes-fiscais-field/QCXSelectCFOPOperacoesFiscaisAutocomplete';
import QCXFinalSelectAplicacaoMercadoriaAutocomplete from '../../shared-components/select-aplicacao-mercadoria/QCXFinalSelectAplicacaoMercadoriaAutocomplete';
import QCXSelectCondicaoVendaAutocomplete from '../../shared-components/select-condicao-venda/QCXSelectCondicaoVendaAutocomplete';
import QCXSelectIncotermCondicaoVendaAutocomplete from '../../shared-components/final-select-incoterm-condicao-venda-field/QCXSelectIncotermCondicaoVendaAutocomplete';
import QCXSelectMetodoValoracaoAutocomplete from '../../shared-components/select-metodo-valoracao/QCXSelectMetodoValoracaoAutocomplete';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXAtributosFundamentoLegalDuimpFormGroup from '../../shared-components/atributos-fundamento-legal-duimp-form-group/QCXAtributosFundamentoLegalDuimpFormGroup';
import QCXAtributosTratamentoTributarioDuimp from '../../shared-components/atributos-tratamento-tributario-duimp/QCXAtributosTratamentoTributarioDuimp';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectInstituicaoFinanciadoraAutocomplete from '../../shared-components/select-instituicao-financiadora/QCXSelectInstituicaoFinanciadoraAutocomplete';
import QCXFormTitle from '../form-title/QCXFormTitle';
import {
  configureGeneralRegimeTributacaoMatcherWith,
  configureSpecificRegimeTributacaoSuspensaoMatcher,
  REGIME_TRIBUTACAO_IMUNIDADE_CODE,
  REGIME_TRIBUTACAO_NAO_INCIDENCIA_CODE,
} from '../../shared-components/select-regime-tributacao/regimeTributacaoUtils';
import { setErrorFeedback, setSuccessFeedback } from '../../features/feedback/feedbackSlice';
import QCXIICommonFormGroup from '../../shared-components/ii-form-group/QCXIICommonFormGroup';
import QCXIPICommonFormGroup from '../../shared-components/ipi-form-group/QCXIPICommonFormGroup';
import QCXPisCofinsCommonFormGroup from '../../shared-components/pis-cofins-form-group/QCXPisCofinsCommonFormGroup';
import QCXIcmsCommonFormGroup from '../../shared-components/icms-form-group/QCXIcmsCommonFormGroup';
import {
  selectRegimesTributacao,
  fetchAllAsync as fetchAllRegimeTributacaoAsync,
} from '../../features/regime-tributacao/regimeTributacaoSlice';

import { fetchAsyncAtributosTratamentosTributarios } from '../../features/tratamento-tributario/tratamentoTributarioThunks';

import useOperationMiddleware from '../../utils/hooks/operation/middleware/useOperationMiddleware';
import QCXConfirmDialog from '../../shared-components/dialog/QCXConfirmDialog';

import { normalizeNumeral, normalizeYear } from '../../utils/general/general-utils';
import {
  TIPO_ACRESCIMO,
  TIPO_DEDUCAO,
} from '../../shared-components/select-tipo-acrescimo-deducao/tipoAcrescimoDeducaoUtils';

import { parseToBoolean } from '../../utils/general/parse-utils';
import {
  COBERTURA_CAMBIAL_COM_COBERTURA_180_360_DIAS,
  COBERTURA_CAMBIAL_COM_COBERTURA_ACIMA_360_DIAS,
  COBERTURA_CAMBIAL_COM_COBERTURA_ATE_180_DIAS,
  COBERTURA_CAMBIAL_SEM_COBERTURA,
  isCoberturaCambialComCoberturaAcima360Dias,
  isCoberturaCambialSemCobertura,
  isSomeCoberturaCambial,
} from '../../shared-components/select-cobertura-cambial/coberturaCambialUtils';
import {
  configureGeneralTipoDeclaracaoMatcherWith,
  getSuggestiveValues,
  TIPO_DECLARACAO_ADMISSAO_EM_ALC_AREA_DE_LIVRE_COMERCIO,
  TIPO_DECLARACAO_ADMISSAO_EM_DAD_DEPOSITO_ADUANEIRO_DE_DISTRIBUICAO,
  TIPO_DECLARACAO_ADMISSAO_EM_DE_DAF,
  TIPO_DECLARACAO_ADMISSAO_EM_EIZOF_ENTREPOSTO_INTERNACIONAL_DA_ZFM,
  TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_ADUANEIRO,
  TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_INDUSTRIAL,
  TIPO_DECLARACAO_ADMISSAO_EM_LOJA_FRANCA,
  TIPO_DECLARACAO_ADMISSAO_NA_ZFM_ZONA_FRANCA_DE_MANAUS,
  TIPO_DECLARACAO_ADMISSAO_TEMPORARIA,
  TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
  TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
  TIPO_DECLARACAO_INTERNACAO_DE_ALC_AREA_DE_LIVRE_COMERCIO,
  TIPO_DECLARACAO_SAIDA_DE_ENTREPOSTO_INDUSTRIAL,
  TIPO_DECLARACAO_DUIMP,
} from '../../shared-components/select-tipo-declaracao/tipoDeclaracaoUtils';

import {
  selectMotivosImportacaoSemCoberturaCambial,
  fetchAllAsync as fetchAllMotivosImportacaoSemCoberturaCambialAsync,
} from '../../features/motivo-importacao-sem-cobertura-cambial/motivoImportacaoSemCoberturaCambialSlice';
import { selectTiposDeclaracao } from '../../features/tipo-declaracao/tipoDeclaracaoSlice';
import { fetchAllAsync as fetchAllFundamentoIiAsync } from '../../features/fundamento-legal-regime-tributacao-ii/fundamentoLegalRegimeTributacaoIiSlice';
import { fetchAllAsync as fetchAllFundamentoPisCofinsAsync } from '../../features/fundamento-legal-pis-cofins/fundamentoLegalPisCofinsSlice';
import { useFornecedorListenersGroup } from '../relacao-fornecedor/relacao-fornecedor-utils';
import useIpiCommonFormGroupListeners from '../../shared-components/ipi-form-group/ipiCommonFormGroupListeners';
import QCXSelectPortoAeroportoAutocomplete from '../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoAutocomplete';
import QCXFinalNumericIntegerField from '../../shared-components/final-numeric-integer-field/QCXFinalNumericIntegerField';

import QCXIIFormGroup from '../../shared-components/ii-form-group/QCXIIFormGroup';
import { BRAZILIAN } from '../../utils/hooks/form/field/mask-types';
import QCXIPIFormGroup from '../../shared-components/ipi-form-group/QCXIPIFormGroup';
import QCXPisCofinsFormGroup from '../../shared-components/pis-cofins-form-group/QCXPisCofinsFormGroup';
import QCXAntidumpingFormGroup from '../../shared-components/antidumping-form-group/QCXAntidumpingFormGroup';
import QCXAFRMMFormGroup from '../../shared-components/afrmm-form-group/QCXAFRMMFormGroup';
import QCXSisComexFormGroup from '../../shared-components/siscomex-form-group/QCXSisComexFormGroup';
import QCXIcmsFormGroup from '../../shared-components/icms-form-group/QCXIcmsFormGroup';
import QCXFinalAtributoNveBondManagerManyAdicoes from './QCXFinalAtributoNveBondManagerManyAdicoes';
import { normalizeAtributosDinamicosNcm, useMercadoriaUtils } from '../fatura/mercadoriaUtils';

import { selectIsLoading } from '../../features/tratamento-tributario/tratamentoTributarioSelectors';

import QCXProgressBackdrop from '../../shared-components/backdrop/QCXProgressBackdrop';

import QCXButton from '../../shared-components/button/QCXButton';

import InputWithCleanButton from './inputWithCleanButton/InputWithCleanButton';

import { setIsLimparCamposActive } from '../../features/limpar-campos-state/limparCamposSlice';
import { selectStale } from '../../features/declaracao-importacao/declaracaoImportacaoSelectors';
import QCXCircularProgress from '../../shared-components/progress/QCXCircularProgress';
import { doPutQCXRequest } from '../../utils/api/domain/domain-api-utils';
import QCXIBSFormGroup from '../../shared-components/ibs-form-group/QCXIBSFormGroup';
import QCXCBSFormGroup from '../../shared-components/cbs-form-group/QCXCBSFormGroup';
import QCXFaturaAtributosNcmDinamico from '../fatura/QCXFaturaAtributosNcmDinamico';
import QCXSelectManyFundamentosOpcionais from './adicoesForm/components/QCXSelectManyFundamentosOpcionais';
import QCXDeclaracaoImportacaoAuxiliarDUIMPImpostosForm from './QCXDeclaracaoImportacaoAuxiliarDUIMPImpostosForm';

const useStyles = makeStyles((theme) => ({
  gridField: {
    paddingBottom: '16px',
  },
  checkboxGridField: {
    paddingBottom: '8px',
  },
  leftSiblingGridField: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: '8px',
    },
  },
  rightSiblingGridField: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: '8px',
    },
  },
  sibling: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '8px',
      marginTop: '8px',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: '8px',
    },
  },
}));

export default function QCXDeclaracaoImportacaoAuxiliarDUIMPForm({
  isLoading,
  isCreate,
  isConsult,
  isUpdate,
  parentModel,
  authInfo,
  requiredRoles,
  handleCustomSaveBy,
  handleChangeToConsult,
  handleChangeToUpdate,
  handleCancelUpdate,
  controlComponentProps,
  isDuimp = false,
  handleSubmit,
  ...restProps
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  const dispatch = useDispatch();

  const mercadoriaUtils = useMercadoriaUtils();

  const hasFetchedMercadoriasRef = useRef(false);

  const regimesTributacao = useSelector(selectRegimesTributacao);
  const motivosImportacaoSemCoberturaCambial = useSelector(selectMotivosImportacaoSemCoberturaCambial);
  const tiposDeclaracao = useSelector(selectTiposDeclaracao);
  const isLoadingTratamentosTributarios = useSelector(selectIsLoading);

  const [isLoadingRepasseAuxiliar, setIsLoadingRepasseAuxiliar] = useState(false);
  const [replicated, setReplicated] = useState(false);

  const idFatura = useMemo(() => parentModel?.id, [parentModel]);
  const idDIDUIMP = useMemo(() => parentModel?.atributosAdicionais?.id, [parentModel]);
  const tipoDeclaracao = useMemo(() => parentModel?.atributosAdicionais?.tipoDeclaracao, [parentModel]);
  const adicoes = useMemo(() => parentModel?.atributosAdicionais?.adicoes || [], [parentModel]);

  useEffect(() => {
    dispatch(fetchAllRegimeTributacaoAsync());
    dispatch(fetchAllMotivosImportacaoSemCoberturaCambialAsync());

    dispatch(fetchAllFundamentoIiAsync(true));
    dispatch(fetchAllFundamentoPisCofinsAsync());
  }, []);

  useEffect(() => {
    if (!adicoes?.[0]?.mercadorias && !hasFetchedMercadoriasRef.current && idDIDUIMP) {
      hasFetchedMercadoriasRef.current = true;
      dispatch(fetchAdicoesByDiDuimpIdAsync(idDIDUIMP));
    }
  }, [idFatura, idDIDUIMP, adicoes]);

  const mercadoriasPorAdicao = useMemo(
    () =>
      adicoes
        .flatMap((adicao) =>
          (adicao?.mercadorias ?? []).map((mercadoria) => ({
            ...mercadoria,
            idAdicao: adicao.id,
            nrAdicao: adicao.item,
            item: mercadoria.item,
            operacaoFiscal: adicao?.operacaoFiscal,
          }))
        )
        .sort((a, b) => a.nrAdicao - b.nrAdicao || a.itemAdicao - b.itemAdicao),
    [adicoes]
  );

  const isSomeTipoDeclaracaoBy = useCallback(
    (codesToCompare) => configureGeneralTipoDeclaracaoMatcherWith(tiposDeclaracao)(tipoDeclaracao?.id, codesToCompare),
    [tiposDeclaracao, tipoDeclaracao]
  );

  const isSuggestibleValues = useMemo(
    () =>
      isSomeTipoDeclaracaoBy([
        TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_ADUANEIRO,
        TIPO_DECLARACAO_ADMISSAO_EM_EIZOF_ENTREPOSTO_INTERNACIONAL_DA_ZFM,
        TIPO_DECLARACAO_ADMISSAO_EM_ENTREPOSTO_INDUSTRIAL,
        TIPO_DECLARACAO_ADMISSAO_TEMPORARIA,
        TIPO_DECLARACAO_ADMISSAO_NA_ZFM_ZONA_FRANCA_DE_MANAUS,
        TIPO_DECLARACAO_ADMISSAO_EM_LOJA_FRANCA,
        TIPO_DECLARACAO_ADMISSAO_EM_ALC_AREA_DE_LIVRE_COMERCIO,
        TIPO_DECLARACAO_ADMISSAO_EM_DAD_DEPOSITO_ADUANEIRO_DE_DISTRIBUICAO,
        TIPO_DECLARACAO_ADMISSAO_EM_DE_DAF,
        TIPO_DECLARACAO_SAIDA_DE_ENTREPOSTO_INDUSTRIAL,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PI_PRODUTO_INDUSTRIALIZADO,
        TIPO_DECLARACAO_INTERNACAO_DA_ZFM_PE_PRODUTO_ESTRANGEIRO,
        TIPO_DECLARACAO_INTERNACAO_DE_ALC_AREA_DE_LIVRE_COMERCIO,
      ]),
    [isSomeTipoDeclaracaoBy]
  );

  const suggestiveValues = useMemo(
    () =>
      getSuggestiveValues({
        regimesTributacao,
        tipoDeclaracao,
        motivosImportacaoSemCoberturaCambial,
      }),
    [getSuggestiveValues, regimesTributacao, tipoDeclaracao, motivosImportacaoSemCoberturaCambial]
  );

  const handleResetFormData = useCallback((form) => {
    form.change('relacao', undefined);
    form.reset({
      relacao: null,
    });
    form.restart({});
  }, []);

  const initialValues = useMemo(
    () => (isSuggestibleValues ? suggestiveValues : {}),
    [isSuggestibleValues, suggestiveValues]
  );

  const tableProps = useMemo(() => {
    return {
      title: 'Mercadorias para repasse',
      columns: [
        {
          field: 'nrAdicao',
          headerName: 'Adição',
          headerAlign: 'center',
          align: 'center',
          flex: 2,
          valueGetter: ({ row }) => row?.nrAdicao || '-',
        },
        {
          field: 'item',
          headerName: 'Item',
          headerAlign: 'center',
          align: 'center',
          flex: 2,
          valueGetter: ({ row }) => row?.itemAdicao || '-',
        },
        {
          field: 'partnumber',
          headerName: 'Partnumber',
          headerAlign: 'center',
          align: 'center',
          flex: 3,
          valueGetter: ({ row }) => row?.partnumber || '-',
        },
        {
          field: 'quebraAuxiliar',
          headerName: t('com.muralis.qcx.mercadoria.quebraAdicional'),
          headerAlign: 'center',
          align: 'center',
          flex: 3,
          valueGetter: ({ row }) => row?.quebraAuxiliar,
        },
        {
          field: 'ncm',
          headerName: t('com.muralis.qcx.NCM.label'),
          flex: 3,
          valueGetter: ({ row }) => row?.ncm?.code || '-',
        },
        {
          field: 'codigoOperacao',
          headerName: 'CFOP',
          headerAlign: 'center',
          align: 'center',
          flex: 2,
          valueGetter: ({ row }) => row?.operacaoFiscal?.code || '-',
        },
        {
          field: 'codigoExportador',
          headerName: 'Código Exp.',
          headerAlign: 'center',
          align: 'center',
          flex: 3,
          valueGetter: ({ row }) => row?.exportador?.id || '-',
        },
        {
          field: 'exportador',
          headerName: t('com.muralis.qcx.exportador.label'),
          headerAlign: 'center',
          align: 'center',
          flex: 4,
          valueGetter: ({ row }) => row?.exportador?.pessoaJuridica?.nomeResumido || '-',
        },
        {
          field: 'codigoFabricante',
          headerName: 'Código Fab.',
          headerAlign: 'center',
          align: 'center',
          flex: 2,
          valueGetter: ({ row }) => row?.fabricante?.id || '-',
        },
        {
          field: 'fabricante',
          headerName: t('com.muralis.qcx.fabricante.label'),
          headerAlign: 'center',
          align: 'center',
          flex: 4,
          valueGetter: ({ row }) => row?.fabricante?.pessoaJuridica?.nomeResumido || '-',
        },
      ],
      data: mercadoriasPorAdicao,
    };
  }, [mercadoriasPorAdicao]);

  const tabManagerProps = useMemo(
    () => ({
      scrollButtons: 'auto',
      variant: 'scrollable',
      tabs: [
        {
          label: t('com.muralis.qcx.detalhes'),
        },
        {
          label: t('com.muralis.qcx.imposto.labelPlural'),
        },
      ],
    }),
    []
  );

  const formatSelection = (item) => ({ ...item });

  const normalizeMercadoria = useCallback(
    (unnormalizedData) => {
      const { atributos, ...restUnnormalizedData } = unnormalizedData;

      const atributosFundamentoItem = _.get(
        unnormalizedData,
        'atributosFundamentoLegalDuimp.atributosPreenchidos.atributos',
        []
      );
      const valorMetadadosFundamento = {};
      let haveMetadados = false;

      if (atributosFundamentoItem) {
        const codigos = Object.keys(atributosFundamentoItem);
        codigos.forEach((codigo) => {
          haveMetadados = true;
          const atributo = atributosFundamentoItem[codigo];
          valorMetadadosFundamento[codigo] = atributo.valor;
        });
      }

      const atributosMultivaloradosFundamentoItem = _.get(
        unnormalizedData,
        'atributosFundamentoLegalDuimp.atributosPreenchidos.atributosMultivalorados',
        []
      );
      if (atributosMultivaloradosFundamentoItem) {
        const codigos = Object.keys(atributosMultivaloradosFundamentoItem);
        codigos.forEach((codigo) => {
          haveMetadados = true;
          const atributo = atributosMultivaloradosFundamentoItem[codigo];

          let valores = atributo.valores;
          if (Array.isArray(atributo.valores)) {
            valores = ';' + atributo.valores.map((a) => a.id).join(';');
          }

          valorMetadadosFundamento[codigo] = valores;
        });
      }

      const valoresFundamentoItem = {
        id: unnormalizedData?.valorMetadadosAtributosFundamento?.id || null,
        mercadoria: {
          id: unnormalizedData.id,
        },
        valorMetadadosJson: valorMetadadosFundamento,
      };

      const normalizedData = mercadoriaUtils.normalize(restUnnormalizedData);
      const normalizedAtributos = (atributos || []).map((atributo) =>
        validate(atributo?.id)
          ? {
              ...atributo,
              id: null,
            }
          : atributo
      );

      const returnNormalized = {
        ...normalizedData,
        atributos: normalizedAtributos,
        listaMercadoriaLPCO:
          unnormalizedData?.listaMercadoriaLPCO?.map((lpco) => ({
            ...lpco,
            id: validate(lpco.id) ? 0 : lpco.id,
          })) ?? [],
        listaMercadoriaDeclaracaoVinculada:
          unnormalizedData?.listaMercadoriaDeclaracaoVinculada?.map((declaracao) => ({
            ...declaracao,
            id: validate(declaracao.id) ? 0 : declaracao.id,
          })) ?? [],
        valorMetadadosAtributosFundamento: haveMetadados ? valoresFundamentoItem : null,
      };

      return returnNormalized;
    },
    [mercadoriaUtils]
  );

  const normalize = useCallback((unnormalizedData) => {
    const mapAcrecimoDeducao = (acrecimoDeducao) => {
      const isUUid = validate(acrecimoDeducao?.id);

      if (isUUid) {
        const obj = {
          ...acrecimoDeducao,
          id: null,
          valorMoeda: normalizeNumeral(acrecimoDeducao?.valorMoeda),
          valorReal: normalizeNumeral(acrecimoDeducao?.valorReal),
          moeda: acrecimoDeducao?.moeda?.id ? acrecimoDeducao?.moeda : null,
          acrescimoValoracaoAduaneira:
            acrecimoDeducao?.acrescimoValoracaoAduaneira?.id && acrecimoDeducao?.tipo === TIPO_ACRESCIMO
              ? acrecimoDeducao?.acrescimoValoracaoAduaneira
              : null,
          deducaoValoracaoAduaneira:
            acrecimoDeducao?.acrescimoValoracaoAduaneira?.id && acrecimoDeducao?.tipo === TIPO_DEDUCAO
              ? acrecimoDeducao?.acrescimoValoracaoAduaneira
              : null,
        };
        return obj;
      }

      const obj = {
        ...acrecimoDeducao,
        valorMoeda: normalizeNumeral(acrecimoDeducao?.valorMoeda),
        valorReal: normalizeNumeral(acrecimoDeducao?.valorReal),
        moeda: acrecimoDeducao?.moeda?.id ? acrecimoDeducao?.moeda : null,
        acrescimoValoracaoAduaneira:
          acrecimoDeducao?.acrescimoValoracaoAduaneira?.id && acrecimoDeducao?.tipo === TIPO_ACRESCIMO
            ? acrecimoDeducao?.acrescimoValoracaoAduaneira
            : null,
        deducaoValoracaoAduaneira:
          acrecimoDeducao?.acrescimoValoracaoAduaneira?.id && acrecimoDeducao?.tipo === TIPO_DEDUCAO
            ? acrecimoDeducao?.acrescimoValoracaoAduaneira
            : null,
      };

      return obj;
    };
    const normalizedAcrescimosDeducoes = (unnormalizedData?.acrescimosDeducoes || [])?.map(mapAcrecimoDeducao);

    let acordoAladi = null;

    if (typeof unnormalizedData?.ii?.acordoAladi === 'number') acordoAladi = { id: unnormalizedData.ii.acordoAladi };
    if (unnormalizedData?.ii?.acordoAladi?.id) acordoAladi = { id: unnormalizedData.ii.acordoAladi.id };

    const firstMercadoriaDecls = unnormalizedData?.mercadorias?.[0]?.listaMercadoriaDeclaracaoVinculada ?? [];

    const adicaoNormalizada = {
      ...unnormalizedData,
      exportador: unnormalizedData?.exportador?.id ? unnormalizedData?.exportador : undefined,
      fabricante: unnormalizedData?.fabricante?.id ? unnormalizedData?.fabricante : undefined,
      paisOrigem: unnormalizedData?.paisOrigem?.id ? unnormalizedData?.paisOrigem : undefined,
      instituicaoFinanciadora: unnormalizedData?.instituicaoFinanciadora?.id
        ? unnormalizedData?.instituicaoFinanciadora
        : undefined,
      motivoImportacaoSemCoberturaCambial: unnormalizedData?.motivoImportacaoSemCoberturaCambial?.id
        ? unnormalizedData?.motivoImportacaoSemCoberturaCambial
        : undefined,
      moeda: unnormalizedData?.moeda?.id ? unnormalizedData?.moeda : null,
      moedaDespesa: unnormalizedData?.moedaDespesa?.id ? unnormalizedData?.moedaDespesa : null,
      ncm: unnormalizedData?.ncm?.id ? unnormalizedData?.ncm : null,
      naladiNcca: unnormalizedData?.naladiNcca?.id ? unnormalizedData?.naladiNcca : null,
      naladiSh: unnormalizedData?.naladiSh?.id ? unnormalizedData?.naladiSh : null,
      operacaoFiscal: unnormalizedData?.operacaoFiscal?.id ? unnormalizedData?.operacaoFiscal : null,
      atributos: (unnormalizedData?.atributos || [])?.map((atributo) =>
        validate(atributo?.id)
          ? {
              ...atributo,
              nve: atributo?.nve?.id ? atributo?.nve : null,
              atributo: atributo?.atributo?.id ? atributo?.atributo : null,
              especificacao: atributo?.especificacao?.id ? atributo?.especificacao : null,
              id: null,
            }
          : {
              ...atributo,
              nve: atributo?.nve?.id ? atributo?.nve : null,
              atributo: atributo?.atributo?.id ? atributo?.atributo : null,
              especificacao: atributo?.especificacao?.id ? atributo?.especificacao : null,
            }
      ),
      declaracaoExportacoes: (unnormalizedData?.declaracaoExportacoes || [])?.map((de) =>
        validate(de?.id)
          ? {
              ...de,
              id: null,
              qtdUnidadeEstatistica: normalizeNumeral(de?.qtdUnidadeEstatistica),
            }
          : {
              ...de,
              qtdUnidadeEstatistica: normalizeNumeral(de?.qtdUnidadeEstatistica),
            }
      ),
      valorFornecedor: normalizeNumeral(unnormalizedData?.valorFornecedor),
      pesoLiquido: normalizeNumeral(unnormalizedData?.pesoLiquido),
      pesoBruto: normalizeNumeral(unnormalizedData?.pesoBruto),
      quantidadeEstatistica: normalizeNumeral(unnormalizedData?.quantidadeEstatistica),
      valorMleReal: normalizeNumeral(unnormalizedData?.valorMleReal),
      valorMleMoeda: normalizeNumeral(unnormalizedData?.valorMleMoeda),
      valorDespesaMoeda: normalizeNumeral(unnormalizedData?.valorDespesaMoeda),
      valorDespesaReal: normalizeNumeral(unnormalizedData?.valorDespesaReal),
      valorCifReal: normalizeNumeral(unnormalizedData?.valorCifReal),
      valorMcvMoeda: normalizeNumeral(unnormalizedData?.valorMcvMoeda),
      valorMcvReal: normalizeNumeral(unnormalizedData?.valorMcvReal),
      valorFreteTerritorioNacionalMoeda: normalizeNumeral(unnormalizedData?.valorFreteTerritorioNacionalMoeda),
      valorFreteTerritorioNacionalReal: normalizeNumeral(unnormalizedData?.valorFreteTerritorioNacionalReal),
      valorSeguroMoeda: normalizeNumeral(unnormalizedData?.valorSeguroMoeda),
      valorSeguroReal: normalizeNumeral(unnormalizedData?.valorSeguroReal),
      valorFreteMoeda: normalizeNumeral(unnormalizedData?.valorFreteMoeda),
      valorFreteReal: normalizeNumeral(unnormalizedData?.valorFreteReal),
      acrescimosDeducoes: normalizedAcrescimosDeducoes,
      incotermCondicaoVenda: unnormalizedData?.incotermCondicaoVenda?.id
        ? unnormalizedData?.incotermCondicaoVenda
        : null,
      metodoValoracaoAduaneira: unnormalizedData?.metodoValoracaoAduaneira?.id
        ? unnormalizedData?.metodoValoracaoAduaneira
        : null,
      portoAeroporto: unnormalizedData?.portoAeroporto?.id ? unnormalizedData?.portoAeroporto : null,
      ii: {
        ...unnormalizedData?.ii,
        fundamentoLegalRegimeTributacaoIi: unnormalizedData?.ii?.fundamentoLegalRegimeTributacaoIi?.id
          ? unnormalizedData?.ii?.fundamentoLegalRegimeTributacaoIi
          : null,
        tipoAtoLegalExTarifario: unnormalizedData?.ii?.tipoAtoLegalExTarifario?.id
          ? unnormalizedData?.ii?.tipoAtoLegalExTarifario
          : null,
        tipoAtoLegalAcordoTarifario: unnormalizedData?.ii?.tipoAtoLegalAcordoTarifario?.id
          ? unnormalizedData?.ii?.tipoAtoLegalAcordoTarifario
          : null,
        regimeTributacao: unnormalizedData?.ii?.regimeTributacao?.id ? unnormalizedData?.ii?.regimeTributacao : null,
        orgaoEmissorAtoLegalExTarifario: unnormalizedData?.ii?.orgaoEmissorAtoLegalExTarifario?.id
          ? unnormalizedData?.ii?.orgaoEmissorAtoLegalExTarifario
          : null,
        orgaoEmissorAtoLegalAcordoTarifario: unnormalizedData?.ii?.orgaoEmissorAtoLegalAcordoTarifario?.id
          ? unnormalizedData?.ii?.orgaoEmissorAtoLegalAcordoTarifario
          : undefined,
        ano: normalizeYear(unnormalizedData?.ii?.ano),
        anoExTarifario: normalizeYear(unnormalizedData?.ii?.anoExTarifario),
        anoAcordoTarifario: normalizeYear(unnormalizedData?.ii?.anoAcordoTarifario),
        baseCalculoReal: normalizeNumeral(unnormalizedData?.ii?.baseCalculoReal),
        aliquota: normalizeNumeral(unnormalizedData?.ii?.aliquota),
        aliquotaAcordo: normalizeNumeral(unnormalizedData?.ii?.aliquotaAcordo),
        percentualReducao: normalizeNumeral(unnormalizedData?.ii?.percentualReducao),
        aliquotaReduzida: normalizeNumeral(unnormalizedData?.ii?.aliquotaReduzida),
        coeficienteReducao: normalizeNumeral(unnormalizedData?.ii?.coeficienteReducao),
        valorDolar: normalizeNumeral(unnormalizedData?.ii?.valorDolar),
        valorReal: normalizeNumeral(unnormalizedData?.ii?.valorReal),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.ii?.valorDevidoReal),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.ii?.valorRecolherReal),
        recolherPermanencia: normalizeNumeral(unnormalizedData?.ii?.recolherPermanencia),
        ...(unnormalizedData?.ii?.acordoAladi && {
          acordoAladi:
            typeof unnormalizedData?.ii?.acordoAladi === 'number'
              ? { id: unnormalizedData?.ii?.acordoAladi }
              : unnormalizedData?.ii?.acordoAladi,
        }),
        // ...normalizeAtributosDinamicosNcm(unnormalizedData?.ii),
      },
      ipi: {
        ...unnormalizedData?.ipi,
        tipoAtoLegalFundamentoLegal: unnormalizedData?.ipi?.tipoAtoLegalFundamentoLegal?.id
          ? unnormalizedData?.ipi?.tipoAtoLegalFundamentoLegal
          : null,
        orgaoEmissorFundamentoLegal: unnormalizedData?.ipi?.orgaoEmissorFundamentoLegal?.id
          ? unnormalizedData?.ipi?.orgaoEmissorFundamentoLegal
          : null,
        numeroAtoFundamentoLegal: unnormalizedData?.ipi?.numeroAtoFundamentoLegal,
        anoFundamentoLegal: normalizeYear(unnormalizedData?.ipi?.anoFundamentoLegal),
        numeroExFundamentoLegal: unnormalizedData?.ipi?.numeroExFundamentoLegal,
        orgaoEmissorAtoLegal: unnormalizedData?.ipi?.orgaoEmissorAtoLegal?.id
          ? unnormalizedData?.ipi?.orgaoEmissorAtoLegal
          : null,
        regimeTributacao: unnormalizedData?.ipi?.regimeTributacao?.id ? unnormalizedData?.ipi?.regimeTributacao : null,
        tipoRecipiente: unnormalizedData?.ipi?.tipoRecipiente?.id ? unnormalizedData?.ipi?.tipoRecipiente : null,
        unidadeDeMedida: unnormalizedData?.ipi?.unidadeDeMedida?.id ? unnormalizedData?.ipi?.unidadeDeMedida : null,
        tipoAtoLegalExTarifario: unnormalizedData?.ipi?.tipoAtoLegalExTarifario?.id
          ? unnormalizedData?.ipi?.tipoAtoLegalExTarifario
          : null,

        baseCalculoReal: normalizeNumeral(unnormalizedData?.ipi?.baseCalculoReal),
        aliquota: normalizeNumeral(unnormalizedData?.ipi?.aliquota),
        aliquotaReduzida: normalizeNumeral(unnormalizedData?.ipi?.aliquotaReduzida),
        valorUnidadeMedidaReal: normalizeNumeral(unnormalizedData?.ipi?.valorUnidadeMedidaReal),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.ipi?.valorRecolherReal),
        recolherPermanencia: normalizeNumeral(unnormalizedData?.ipi?.recolherPermanencia),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.ipi?.valorDevidoReal),
        quantidade: normalizeNumeral(unnormalizedData?.ipi?.quantidade),
        capacidade: normalizeNumeral(unnormalizedData?.ipi?.capacidade),
        anoExTarifario: normalizeYear(unnormalizedData?.ipi?.anoExTarifario),
      },
      multaLi: {
        ...unnormalizedData?.multaLi,
        valorDevidoReal: normalizeNumeral(unnormalizedData?.multaLi?.valorDevidoReal),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.multaLi?.valorRecolherReal),
      },
      pisCofins: {
        ...unnormalizedData?.pisCofins,
        unidadeDeMedidaPisPasep: unnormalizedData?.pisCofins?.unidadeDeMedidaPisPasep?.id
          ? unnormalizedData?.pisCofins?.unidadeDeMedidaPisPasep
          : null,
        unidadeDeMedidaCofins: unnormalizedData?.pisCofins?.unidadeDeMedidaCofins?.id
          ? unnormalizedData?.pisCofins?.unidadeDeMedidaCofins
          : null,
        regimeTributacao: unnormalizedData?.pisCofins?.regimeTributacao?.id
          ? unnormalizedData?.pisCofins?.regimeTributacao
          : null,
        fundamentoLegalRegimeTributacaoPisCofins: unnormalizedData?.pisCofins?.fundamentoLegalRegimeTributacaoPisCofins
          ?.id
          ? unnormalizedData?.pisCofins?.fundamentoLegalRegimeTributacaoPisCofins
          : null,
        fundamentoLegal: unnormalizedData?.pisCofins?.fundamentoLegal?.id
          ? unnormalizedData?.pisCofins?.fundamentoLegal
          : null,
        baseCalculoReal: normalizeNumeral(unnormalizedData?.pisCofins?.baseCalculoReal),
        percentualReducao: normalizeNumeral(unnormalizedData?.pisCofins?.percentualReducao),
        percentualReducaoBaseCalculo: normalizeNumeral(unnormalizedData?.pisCofins?.percentualReducaoBaseCalculo),
        aliquotaPisPasep: normalizeNumeral(unnormalizedData?.pisCofins?.aliquotaPisPasep),
        aliquotaReduzidaPisPasep: normalizeNumeral(unnormalizedData?.pisCofins?.aliquotaReduzidaPisPasep),
        valorRecolherPisPasepReal: normalizeNumeral(unnormalizedData?.pisCofins?.valorRecolherPisPasepReal),
        valorDevidoCofinsReal: normalizeNumeral(unnormalizedData?.pisCofins?.valorDevidoCofinsReal),
        valorDevidoPisPasepReal: normalizeNumeral(unnormalizedData?.pisCofins?.valorDevidoPisPasepReal),
        recolherPermanenciaPisPasep: normalizeNumeral(unnormalizedData?.pisCofins?.recolherPermanenciaPisPasep),
        recolherPermanenciaCofins: normalizeNumeral(unnormalizedData?.pisCofins?.recolherPermanenciaCofins),
        quantidadePisPasep: normalizeNumeral(unnormalizedData?.pisCofins?.quantidadePisPasep),
        aliquotaCofins: normalizeNumeral(unnormalizedData?.pisCofins?.aliquotaCofins),
        aliquotaReduzidaCofins: normalizeNumeral(unnormalizedData?.pisCofins?.aliquotaReduzidaCofins),
        valorRecolherCofinsReal: normalizeNumeral(unnormalizedData?.pisCofins?.valorRecolherCofinsReal),
        quantidadeCofins: normalizeNumeral(unnormalizedData?.pisCofins?.quantidadeCofins),
        // normalize atributos
        // ...normalizeAtributosDinamicosNcm(unnormalizedData?.pisCofins),
      },
      taxaSiscomex: {
        ...unnormalizedData?.taxaSiscomex,
        valorReal: normalizeNumeral(unnormalizedData?.taxaSiscomex?.valorReal),
        valorDolar: normalizeNumeral(unnormalizedData?.taxaSiscomex?.valorDolar),
        valorMoeda: normalizeNumeral(unnormalizedData?.taxaSiscomex?.valorMoeda),
      },
      ibs: {
        ...unnormalizedData?.ibs,
        regimeTributacao: unnormalizedData?.ibs?.regimeTributacao?.id ? unnormalizedData?.ibs?.regimeTributacao : null,
        aliquota: normalizeNumeral(unnormalizedData?.ibs?.aliquota),
        aliquotaReduzida: normalizeNumeral(unnormalizedData?.ibs?.aliquotaReduzida),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.ibs?.valorRecolherReal),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.ibs?.valorDevidoReal),
        baseCalculoReal: normalizeNumeral(unnormalizedData?.ibs?.baseCalculoReal),
      },
      cbs: {
        ...unnormalizedData?.cbs,
        regimeTributacao: unnormalizedData?.cbs?.regimeTributacao?.id ? unnormalizedData?.cbs?.regimeTributacao : null,
        aliquota: normalizeNumeral(unnormalizedData?.cbs?.aliquota),
        aliquotaReduzida: normalizeNumeral(unnormalizedData?.cbs?.aliquotaReduzida),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.cbs?.valorRecolherReal),
        valorRecolherMoeda: normalizeNumeral(unnormalizedData?.cbs?.valorRecolherMoeda),
        valorRecolherDolar: normalizeNumeral(unnormalizedData?.cbs?.valorRecolherDolar),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.cbs?.valorDevidoReal),
        valorDevidoMoeda: normalizeNumeral(unnormalizedData?.cbs?.valorDevidoMoeda),
        valorDevidoDolar: normalizeNumeral(unnormalizedData?.cbs?.valorDevidoDolar),
        baseCalculoReal: normalizeNumeral(unnormalizedData?.cbs?.baseCalculoReal),
        baseCalculoMoeda: normalizeNumeral(unnormalizedData?.cbs?.baseCalculoMoeda),
        baseCalculoDola: normalizeNumeral(unnormalizedData?.cbs?.baseCalculoDolar),
      },
      icms: {
        ...unnormalizedData?.icms,
        regimeTributacao: unnormalizedData?.icms?.regimeTributacao?.id
          ? unnormalizedData?.icms?.regimeTributacao
          : null,
        dispositivoLegal: unnormalizedData?.icms?.dispositivoLegal?.id
          ? unnormalizedData?.icms?.dispositivoLegal
          : null,
        baseCalculoReal: normalizeNumeral(unnormalizedData?.icms?.baseCalculoReal),
        aliquota: normalizeNumeral(unnormalizedData?.icms?.aliquota),
        aliquotaAntecipadaPercentual: normalizeNumeral(unnormalizedData?.icms?.aliquotaAntecipadaPercentual),
        aliquotaOriginal: normalizeNumeral(unnormalizedData?.icms?.aliquotaOriginal),
        aliquotaFecp: normalizeNumeral(unnormalizedData?.icms?.aliquotaFecp),
        percentualReducao: normalizeNumeral(unnormalizedData?.icms?.percentualReducao),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.icms?.valorRecolherReal),
        recolherPermanencia: normalizeNumeral(unnormalizedData?.icms?.recolherPermanencia),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.icms?.valorDevidoReal),
        percentualBeneficio: normalizeNumeral(unnormalizedData?.icms?.percentualBeneficio),
        baseSubstTrib: normalizeNumeral(unnormalizedData?.icms?.baseSubstTrib),
        percMva: normalizeNumeral(unnormalizedData?.icms?.percMva),
        valorDevidoSubstTrib: normalizeNumeral(unnormalizedData?.icms?.valorDevidoSubstTrib),
        substTributaria: normalizeNumeral(unnormalizedData?.icms?.substTributaria),
      },
      antidumping: {
        ...unnormalizedData?.antidumping,
        orgaoEmissorAtoLegal: unnormalizedData?.antidumping?.orgaoEmissorAtoLegal?.id
          ? unnormalizedData?.antidumping?.orgaoEmissorAtoLegal
          : null,
        unidadeDeMedida: unnormalizedData?.antidumping?.unidadeDeMedida?.id
          ? unnormalizedData?.antidumping?.unidadeDeMedida
          : null,
        tipoAtoLegal: unnormalizedData?.antidumping?.tipoAtoLegal?.id
          ? unnormalizedData?.antidumping?.tipoAtoLegal
          : null,
        ano: normalizeYear(unnormalizedData?.antidumping?.ano),
        aliquota: normalizeNumeral(unnormalizedData?.antidumping?.aliquota),
        valorReal: normalizeNumeral(unnormalizedData?.antidumping?.valorReal),
        quantidade: normalizeNumeral(unnormalizedData?.antidumping?.quantidade),
        baseCalculoReal: normalizeNumeral(unnormalizedData?.antidumping?.baseCalculoReal),
        valorRecolherReal: normalizeNumeral(unnormalizedData?.antidumping?.valorRecolherReal),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.antidumping?.valorDevidoReal),
      },
      afrmm: {
        ...unnormalizedData?.afrmm,
        valorRecolherReal: normalizeNumeral(unnormalizedData?.afrmm?.valorRecolherReal),
        valorDevidoReal: normalizeNumeral(unnormalizedData?.afrmm?.valorDevidoReal),
      },
      valorDespesaAcessoriaReal: normalizeNumeral(unnormalizedData?.valorDespesaAcessoriaReal),
      mercadorias: [normalizeMercadoria(unnormalizedData)],
    };

    // normaliza atributos de fundamento legal da duimp
    const atributosNormalizadosCat = normalizeAtributosDinamicosNcm(unnormalizedData?.atributosFundamentoLegalDuimp); // essa funcao normaliza para o catalogo, necessario adaptar

    if (atributosNormalizadosCat && atributosNormalizadosCat.atributosSimples) {
      adicaoNormalizada.atributosSimplesFundamentoLegalDuimp = atributosNormalizadosCat.atributosSimples;
    }

    if (adicaoNormalizada && adicaoNormalizada.atributosPreenchidos) delete adicaoNormalizada.atributosPreenchidos;
    if (adicaoNormalizada && adicaoNormalizada.atributosFundamentoLegalDuimp)
      delete adicaoNormalizada.atributosFundamentoLegalDuimp;

    // NORMALIZA TRATAMENTOS TRIBUTARIOS
    const atributosTratamento = unnormalizedData?.atributosTratamentoTributario?.atributosPreenchidos?.atributos;
    let atributos = [];

    if (atributosTratamento && _.isObject(atributosTratamento)) atributos = Object.keys(atributosTratamento);

    if (adicaoNormalizada.valoresMetadadoTtce && atributosTratamento) {
      try {
        adicaoNormalizada.valoresMetadadoTtce.valorMetadadosJson = atributosTratamento;
      } catch (e) {
        console.error('Erro durante atribuição:', e);
      }
    } else if (atributosTratamento) {
      adicaoNormalizada.valoresMetadadoTtce = {
        valorMetadadosJson: atributosTratamento,
        diDuimpAdicao: { id: adicaoNormalizada.id },
        id: null,
      };
    }

    try {
      // NORMALIZA TRATAMENTOS TRIBUTARIOS / 2
      const tratamentosTtce = _.get(unnormalizedData, 'ignorableFields.tratamentosTtce.metadados', null);
      const idTratamento = _.get(unnormalizedData, 'valoresMetadadoTtce.id', null);

      const tratamentosNormalizadosTtce = {
        opcionais: {},
        obrigatorios: {},
      };

      if (tratamentosTtce?.obrigatorios) {
        tratamentosTtce.obrigatorios.forEach((tratamento) => {
          const codigoTrf = `${tratamento?.tributo?.codigo};${tratamento?.regime?.codigo};${tratamento?.fundamento?.id}`;

          const tratamentoAtual = {
            tributo: { codigo: tratamento?.tributo?.codigo },
            regime: { codigo: tratamento?.regime?.codigo },
            fundamento: { codigo: tratamento?.fundamento?.id },
            atributos: [],
          };

          tratamentosNormalizadosTtce.obrigatorios[codigoTrf] = tratamentoAtual;
        });
      }

      if (tratamentosTtce?.opcionais && _.isArray(tratamentosTtce.opcionais)) {
        tratamentosTtce.opcionais.forEach((tratamento) => {
          const codigoTrf = `${tratamento?.tributo?.codigo};${tratamento?.regime?.codigo};${tratamento?.fundamento?.id}`;

          const tratamentoAtual = {
            tributo: { codigo: tratamento?.tributo?.codigo },
            regime: { codigo: tratamento?.regime?.codigo },
            fundamento: { codigo: tratamento?.fundamento?.id },
            atributos: [],
          };

          tratamentosNormalizadosTtce.opcionais[codigoTrf] = tratamentoAtual;
        });
      }

      if (tratamentosTtce?.valores && _.isObject(tratamentosTtce.valores)) {
        Object.keys(tratamentosTtce.valores).forEach((key) => {
          const valorMetadado = tratamentosTtce.valores[key];

          const codTratamentosPossiveis = valorMetadado?.codTratamentosPossiveis ?? [valorMetadado.codTratamento];
          const codigoCampo = valorMetadado.codigo;
          const valorCampo = valorMetadado.valor;

          const codTratamentoOpcionalSelecionado = Object.keys(tratamentosNormalizadosTtce.opcionais).find((codTrat) =>
            codTratamentosPossiveis.includes(codTrat)
          );
          const codTratamentoObrigatorioSelecionado = Object.keys(tratamentosNormalizadosTtce.obrigatorios).find(
            (codTrat) => codTratamentosPossiveis.includes(codTrat)
          );

          if (codTratamentoOpcionalSelecionado) {
            tratamentosNormalizadosTtce.opcionais[codTratamentoOpcionalSelecionado].atributos.push({
              codigo: codigoCampo,
              valor: valorCampo,
            });
          } else if (codTratamentoObrigatorioSelecionado) {
            tratamentosNormalizadosTtce.obrigatorios[codTratamentoObrigatorioSelecionado].atributos.push({
              codigo: codigoCampo,
              valor: valorCampo,
            });
          }
        });
      }

      const propagarAtributosPorFundamento = (tratamentos) => {
        const atributosPorFundamento = {};

        Object.values(tratamentos).forEach((tratamento) => {
          if (!_.isArray(tratamento?.atributos) || tratamento.atributos.length === 0) return;
          const codigoFundamento = tratamento?.fundamento?.codigo;
          if (!codigoFundamento) return;
          atributosPorFundamento[codigoFundamento] = tratamento.atributos;
        });

        Object.values(tratamentos).forEach((tratamento) => {
          if (!_.isArray(tratamento?.atributos) || tratamento.atributos.length > 0) return;
          const codigoFundamento = tratamento?.fundamento?.codigo;
          if (!codigoFundamento) return;
          const atributos = atributosPorFundamento[codigoFundamento];
          if (atributos) {
            tratamento.atributos = atributos;
          }
        });
      };

      propagarAtributosPorFundamento(tratamentosNormalizadosTtce.opcionais);
      propagarAtributosPorFundamento(tratamentosNormalizadosTtce.obrigatorios);

      adicaoNormalizada.valoresMetadadoTtce = {
        valorMetadadosJson: tratamentosNormalizadosTtce,
        diDuimpAdicao: { id: adicaoNormalizada.id },
        id: idTratamento,
      };
    } catch (e) {
      console.log(e);
    }

    if (adicaoNormalizada && adicaoNormalizada.atributosTratamentoTributario)
      delete adicaoNormalizada.atributosTratamentoTributario;

    return adicaoNormalizada;
  }, []);

  const handleSubmitAuxiliar = async (values, form) => {
    try {
      setIsLoadingRepasseAuxiliar(true);

      const itensSelecionados = values?.meta?.selected;

      if (!itensSelecionados || itensSelecionados?.length === 0) {
        dispatch(setErrorFeedback({ message: 'Selecione pelo menos 1 item para repassar as informações.' }));
        return;
      }

      const camposParaLimpar = Object.keys(values?.ignorableFields?.limparCampos ?? {}).filter(
        (campoNome) => values?.ignorableFields?.limparCampos?.[campoNome] === true
      );

      const repassarTratamentosTributarios = !!values?.ignorableFields?.repassarTratamentosTributarios;

      const payload = {
        itensRepasse: itensSelecionados,
        adicaoBase: normalize(values),
        camposParaLimpar,
        repassarTratamentosTributarios,
      };

      console.log('payload', payload);

      await doPutQCXRequest(['diduimp', 'repasse-auxiliar-duimp', idFatura], payload);

      dispatch(
        setSuccessFeedback({
          message: 'Informações repassadas com sucesso!',
        })
      );

      dispatch(fetchAdicoesByDiDuimpIdAsync(idDIDUIMP));

      handleChangeToConsult();
    } catch (error) {
      console.log(error);
      dispatch(
        setErrorFeedback({
          message: 'Erro ao repassar informações para as adições selecionadas.',
        })
      );
    } finally {
      setIsLoadingRepasseAuxiliar(false);
    }
  };

  const renderRelacaoFornecedorSiblings = useCallback(
    (values) => (
      <Grid item className={classes.sibling} xs={12} sm={12} md={12} lg={12}>
        <InputWithCleanButton>
          <QCXSelectVinculoCompradorVendedorAutocomplete
            id="autocomplete-select-vinculo-comprador-vendedor-field"
            key="autocomplete-select-vinculo-comprador-vendedor-field"
            name="vinculacaoCompradorVendedor"
            label={t('com.muralis.qcx.vinculacaoCompradorVendedor')}
            initialValues={values}
            disabled={isConsult}
          />
        </InputWithCleanButton>
      </Grid>
    ),
    [classes, isConsult]
  );

  return (
    <>
      {isLoadingRepasseAuxiliar ? <QCXProgressBackdrop open /> : null}

      <QCXFormStepWizard
        initialValues={initialValues}
        onSubmit={handleSubmitAuxiliar}
        controlComponentProps={controlComponentProps}
        disableSubmitOnNext
        {...restProps}
      >
        {({ values, submitSucceeded }) => (
          <>
            <QCXFinalFormDataReplicator
              isConsult={isConsult}
              tableProps={tableProps}
              onReset={handleResetFormData}
              replicated={replicated}
              handleSetReplicated={setReplicated}
              clearSelection={isConsult}
              formatSelection={formatSelection}
              customControlButtons={[
                {
                  description: 'Buscar tratamentos',
                  color: 'secondary',
                  startIcon: <PersonSearchIcon />,
                  tooltip: {
                    description: 'Repassar Dados',
                  },
                  disabled: isConsult,
                  onClick: () => {
                    dispatch(fetchAsyncAtributosTratamentosTributarios(idFatura));
                  },
                },
              ]}
              hideControlButtons
            >
              <>
                <Grid
                  item
                  container
                  style={{
                    paddingTop: '24px',
                  }}
                >
                  <QCXTabsManager {...tabManagerProps}>
                    {/* PRIMEIRA TAB */}
                    <>
                      <Grid item container spacing={2}>
                        <QCXRelacaoFornecedorFieldGroup
                          isConsult={isConsult}
                          relacao={values?.relacao}
                          fabricante={values?.fabricante}
                          exportador={values?.exportador}
                          required={false}
                          initialValues={values}
                          renderSiblings={renderRelacaoFornecedorSiblings}
                          authInfo={authInfo}
                        />
                        <Grid item container alignContent="flex-start" xs={12} sm={12} md={6} lg={6}>
                          <Grid item className={classes.gridField} xs={12} sm={12} md={12} lg={12}>
                            <InputWithCleanButton>
                              <QCXSelectCFOPOperacoesFiscaisAutocomplete
                                id="text-cfop-operacoes-fiscais-field"
                                key="text-cfop-operacoes-fiscais-field"
                                name="operacaoFiscal"
                                label={t('com.muralis.qcx.CFOP.label')}
                                initialValues={values}
                                disabled={isConsult}
                              />
                            </InputWithCleanButton>
                          </Grid>
                          <Grid item className={classes.gridField} xs={12} sm={12} md={12} lg={12}>
                            <InputWithCleanButton>
                              <QCXSelectCoberturaCambialAutocomplete
                                id="autocomplete-select-cobertura-cambial-field"
                                key="autocomplete-select-cobertura-cambial-field"
                                name="coberturaCambial"
                                label={t('com.muralis.qcx.coberturaCambial')}
                                initialValues={values}
                                disabled={isConsult}
                              />
                            </InputWithCleanButton>
                          </Grid>
                          {isCoberturaCambialComCoberturaAcima360Dias(values?.coberturaCambial) && (
                            <Grid item className={classes.gridField} xs={12} sm={12} md={12} lg={12}>
                              <InputWithCleanButton>
                                <QCXSelectInstituicaoFinanciadoraAutocomplete
                                  id="autocomplete-select-instituicao-financiadora-field"
                                  key="autocomplete-select-instituicao-financiadora-field"
                                  name="instituicaoFinanciadora.id"
                                  label={t('com.muralis.qcx.instituicaoFinanceira')}
                                  initialValues={values}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                          )}
                          {isCoberturaCambialSemCobertura(values?.coberturaCambial) && (
                            <Grid item className={classes.gridField} xs={12} sm={12} md={12} lg={12}>
                              <InputWithCleanButton>
                                <QCXSelectMotivoImportacaoSemCoberturaCambialAutocomplete
                                  id="autocomplete-select-motivo-importacao-sem-cobertura-cambial-field"
                                  key="autocomplete-select-motivo-importacao-sem-cobertura-cambial-field"
                                  name="motivoImportacaoSemCoberturaCambial.id"
                                  label={t('com.muralis.qcx.motivo')}
                                  initialValues={values}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                          )}
                          <Grid item className={classes.rightSiblingGridField} xs={12} sm={12} md={6} lg={6}>
                            <InputWithCleanButton>
                              <QCXSelectCondicaoVendaAutocomplete
                                id="select-field-local-condicao-mercadoria"
                                key="select-field-local-condicao-mercadoria"
                                name="condicaoMercadoria"
                                label={t('com.muralis.qcx.mercadoria.condicaoMercadoria')}
                                initialValues={values}
                                disabled={isConsult}
                              />
                            </InputWithCleanButton>
                          </Grid>
                          <Grid item className={classes.leftSiblingGridField} xs={12} sm={12} md={6} lg={6}>
                            <InputWithCleanButton>
                              <QCXFinalSelectAplicacaoMercadoriaAutocomplete
                                id="select-field-aplicacao-mercadoria"
                                key="select-field-aplicacao-mercadoria"
                                name="aplicacaoMercadoria"
                                label={t('com.muralis.qcx.mercadoria.aplicacaoMercadoria')}
                                initialValues={values}
                                disabled={isConsult}
                                isDuimp={isDuimp}
                              />
                            </InputWithCleanButton>
                          </Grid>
                        </Grid>
                        <Grid item container alignContent="flex-start" xs={12} sm={12} md={6} lg={6}>
                          <Grid item className={classes.gridField} xs={12} sm={12} md={12} lg={12}>
                            <InputWithCleanButton>
                              <QCXSelectIncotermCondicaoVendaAutocomplete
                                id="select-field-incoterm"
                                key="select-field-incoterm"
                                name="incotermCondicaoVenda.id"
                                label={t('com.muralis.qcx.incoterm')}
                                initialValues={values}
                                disabled={isConsult}
                              />
                            </InputWithCleanButton>
                          </Grid>
                          <Grid item className={classes.gridField} xs={12} sm={12} md={12} lg={12}>
                            <InputWithCleanButton>
                              <QCXSelectMetodoValoracaoAutocomplete
                                id="select-field-metodo-de-valoracao"
                                key="select-field-metodo-de-valoracao"
                                name="metodoValoracaoAduaneira.id"
                                label={t('com.muralis.qcx.metodoValoracao')}
                                initialValues={values}
                                disabled={isConsult}
                              />
                            </InputWithCleanButton>
                          </Grid>
                          {isCoberturaCambialComCoberturaAcima360Dias(values?.coberturaCambial) && (
                            <Grid
                              item
                              style={{
                                paddingBottom: '16px',
                              }}
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                            >
                              <InputWithCleanButton>
                                <QCXFinalAlternativeCurrencyField
                                  id="currency-valor-fornecedor-field"
                                  key="currency-valor-fornecedor-field"
                                  name="valorFornecedor"
                                  label={t('com.muralis.qcx.valor')}
                                  submitSucceeded={submitSucceeded}
                                  scale={7}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                          )}
                          {isSomeCoberturaCambial(values?.coberturaCambial, [
                            COBERTURA_CAMBIAL_SEM_COBERTURA,
                            COBERTURA_CAMBIAL_COM_COBERTURA_ACIMA_360_DIAS,
                          ]) && (
                            <Grid item className={classes.rightSiblingGridField} xs={12} sm={12} md={6} lg={6}>
                              <InputWithCleanButton>
                                <QCXFinalTextField
                                  id="text-field-numero-rof"
                                  key="text-field-numero-rof"
                                  name="numeroRof"
                                  label={t('com.muralis.qcx.numeroROF')}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                          )}
                          {!isDuimp ? (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              {...(!isSomeCoberturaCambial(values?.coberturaCambial, [
                                COBERTURA_CAMBIAL_SEM_COBERTURA,
                                COBERTURA_CAMBIAL_COM_COBERTURA_ACIMA_360_DIAS,
                              ])
                                ? {
                                    md: 12,
                                    lg: 12,
                                  }
                                : {
                                    className: classes.leftSiblingGridField,
                                    md: 6,
                                    lg: 6,
                                  })}
                            >
                              <InputWithCleanButton>
                                <QCXFinalTextField
                                  id="text-field-destaque-ncm"
                                  key="text-field-destaque-ncm"
                                  name="destaqueNcm"
                                  label={t('com.muralis.qcx.NCM.destaqueNCM')}
                                  maxLength={3}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                          ) : null}
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6}>
                          <InputWithCleanButton>
                            <QCXSelectPortoAeroportoAutocomplete
                              id="select-field-local-condicao-venda"
                              key="select-field-local-condicao-venda"
                              name="portoAeroporto.id"
                              label={t('com.muralis.qcx.localCondicaoVenda')}
                              disabled={isConsult}
                              initialValues={values}
                            />
                          </InputWithCleanButton>
                        </Grid>

                        {!isDuimp ? (
                          <Grid item xs={6} sm={6} md={6} lg={6}>
                            <InputWithCleanButton>
                              <QCXFinalNumericIntegerField
                                id="text-field-quebra-auxiliar"
                                key="text-field-quebra-auxiliar"
                                name="quebraAuxiliar"
                                label={t('com.muralis.qcx.mercadoria.quebraAdicional')}
                                disabled={isConsult}
                              />
                            </InputWithCleanButton>
                          </Grid>
                        ) : null}

                        {!isDuimp ? (
                          <Grid item container alignContent="flex-start" xs={12} sm={12} md={12} lg={12}>
                            <Grid item xs={12}>
                              <QCXFormSubtitle
                                title={t('com.muralis.qcx.adicao.quebraAdicao')}
                                boxProps={{
                                  pt: 1,
                                  pb: 1,
                                }}
                              />
                            </Grid>
                            <Grid item className={classes.checkboxGridField} xs={12} sm={6} md={3} lg={3}>
                              <InputWithCleanButton>
                                <QCXFinalCheckboxField
                                  id="checkbox-quebra-adicao-cfop-field"
                                  key="checkbox-quebra-adicao-cfop-field"
                                  name="quebraAdicaoCfop"
                                  label={t('com.muralis.qcx.porCFOP')}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                            <Grid item className={classes.checkboxGridField} xs={12} sm={6} md={3} lg={3}>
                              <InputWithCleanButton>
                                <QCXFinalCheckboxField
                                  id="checkbox-quebra-adicao-numero-fatura-field"
                                  key="checkbox-quebra-adicao-numero-fatura-field"
                                  name="quebraAdicaoNumeroFatura"
                                  label={t('com.muralis.qcx.porNumeroFatura')}
                                  disabled={isConsult}
                                />
                              </InputWithCleanButton>
                            </Grid>
                          </Grid>
                        ) : null}

                        {isDuimp ? (
                          <Grid item container alignContent="flex-start" xs={12} sm={12} md={12} lg={12}>
                            <Grid item xs={12}>
                              <QCXFaturaAtributosNcmDinamico
                                modes={{ isConsult, isSubConsult: false }}
                                codObjetivo="5"
                                defaultNcm={adicoes?.[0]?.ncm}
                                somenteClasseTrib
                              />
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                    </>

                    {/* SEGUNDA TAB */}
                    <>
                      <QCXDeclaracaoImportacaoAuxiliarDUIMPImpostosForm
                        values={values}
                        isConsult={isConsult}
                        idFatura={idFatura}
                      />
                    </>
                  </QCXTabsManager>
                </Grid>
              </>
            </QCXFinalFormDataReplicator>
          </>
        )}
      </QCXFormStepWizard>
    </>
  );
}
